<template>
  <section class="hero is-fullheight">
    <div class="hero-body">
      <div class="container has-text-centered">
        <div class="column is-4 is-offset-4">
          <router-view />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { bodyClassMixin } from '@/mixins/bodyClass'

  export default {
    mixins: [ bodyClassMixin('auth') ],
  }
</script>

<style lang="scss">
  @import '@/assets/scss/global';
  @import '@/assets/scss/auth';
</style>
